import { getContext, onDestroy } from 'svelte';
import { get, type Writable } from 'svelte/store';
import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

/**
 * Sticky footer action for settings panes.
 *
 * Svelte may mount the next pane before destroying the previous one. Clearing
 * the context unconditionally on destroy then hides the new pane's Save.
 * This helper only clears when this instance still owns the current action.
 */
export function bindStickyBottomAction() {
	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');
	let owned: SidepanelStickyBottomProps | null = null;

	function setStickyBottomAction(action: SidepanelStickyBottomProps | null) {
		if (!stickyBottomAction) return;

		if (action) {
			owned = action;
			stickyBottomAction.set(action);
			return;
		}

		if (get(stickyBottomAction) === owned) {
			owned = null;
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => setStickyBottomAction(null));

	return { stickyBottomAction, setStickyBottomAction };
}
